import { queryMemberPageApi } from '@eastcoal/api/auth/operationMember/queryMemberPage'

import { RemoteTransfer } from '@eastcoal/common/components/RemoteTransfer'

import { MemberType } from '@eastcoal/shared/enums/MemberType'

import { LimitMemberTransferProps } from './interface'

const leftColumns: LimitMemberTransferProps['leftColumns'] = [
  {
    title: '会员名称',
    dataIndex: 'name',
    align: 'center',
    width: 340
  },
  {
    title: '会员类型',
    dataIndex: 'type',
    align: 'center',
    valueEnum: {
      [MemberType.PERSON]: {
        text: '个人',
        tag: true
      },
      [MemberType.ENTERPRISE]: {
        text: '企业',
        tag: true
      }
    }
  },
  {
    title: '业务委托人',
    dataIndex: 'agentName',
    align: 'center'
  },
  {
    title: '委托人手机',
    dataIndex: 'agentPhone',
    align: 'center'
  }
]

const rightColumns: LimitMemberTransferProps['rightColumns'] = [
  {
    dataIndex: 'name',
    title: '会员'
  }
]

const filterOption: LimitMemberTransferProps['rightFilterOption'] = (
  searchVal,
  item
) => {
  return !!(item.name?.includes(searchVal) || item.name?.includes(searchVal))
}

export const LimitMemberTransfer = ({
  /* -------------------------------------------------------------------------- */
  /*                             TableTransfer Props                            */
  /* -------------------------------------------------------------------------- */
  height = 300,
  ...restProps
}: LimitMemberTransferProps) => {
  return (
    <RemoteTransfer
      {...restProps}
      api={queryMemberPageApi}
      height={height}
      leftColumns={leftColumns}
      rightColumns={rightColumns}
      rightFilterOption={filterOption}
      rowKey='id'
      titles={['未选择', '已选择']}
      requestParams={{
        all: true,
        type: MemberType.ENTERPRISE
      }}
    />
  )
}
